import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import history from "../history";
import { Button } from "../common";
import * as style from "./RightToWork/styles.module.scss";

const YotiCheckFailed = ({ nextStepLink, findStep, jobId }) => {
  return (
    <Fragment>
      <div>
        <div className="mb-1">
          <p className="mb-1 font-weight-bold">
            Sorry your Right to work check was unsuccessful.
          </p>
          <p>
            Please try again, or speak to our Customer Success team for further
            assistance. <br />
            They are available Monday - Friday between 9am – 5.30pm on 01233
            515169 or via email at{" "}
            <a href="mailto:customer.success@hrgo.co.uk">
              customer.success@hrgo.co.uk
            </a>
            .
          </p>
        </div>
      </div>
      <div className={`mt-auto mb-lg-2 ${style.actions}`}>
        <Link to={findStep("contract-for-services", jobId)}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <Button
          classes="btn btn-primary btn-block"
          onClick={() => {
            history.push(nextStepLink);
          }}
        >
          Next
        </Button>
      </div>
    </Fragment>
  );
};

export default YotiCheckFailed;
